import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import Button from '../../../../../generic-components/Button';
import Heading from '../../../../../generic-components/Heading';
import { refactoredTimeAndDate } from '../../../../../helpers/timeFormatter.helper';
import { DATE_FORMAT } from '../../../../../constants/general';
import Icon from '../../../../../generic-components/Icon';
import ArrowIcon from '../../../../../assets/svg/Down-arrow.svg';
import { getFutureDateFromSpecificDate } from '../../../../../helpers/datesAndTime.helper';
import { STYLES } from '../../consts/consts';

const { INVOICE_CREATION: { INVOICE_DATES_PICKER: componentStyles } } = STYLES;

interface IDueDateItem {
    title: string;
    value: number | null;
    id: string;
}

interface IProps {
    dueDates: IDueDateItem[];
    issueDate: Date;
    onDueDateSelected: (date: Date, id: string) => void;
}

export const DueDatePicker = ({ dueDates, issueDate, onDueDateSelected }: IProps) => {
  const [selectedDueDateItemId, setSelectedDueDateItemId] = useState<number>(0);
  const [isDatePickerShown, setIsDatePickerShown] = useState<boolean>(false);
  const elWrapper = useRef<HTMLDivElement>(null);

  const handleItemClick = (idx: number) => {
    setSelectedDueDateItemId(idx);
    setIsDatePickerShown(false);
    // onDueDateSelected(getFutureDateFromSpecificDate(dueDates?.[idx]?.value || 0, new Date()));
  };

  const activeDueDateItem = useMemo(() => dueDates[selectedDueDateItemId], [selectedDueDateItemId]);

  const activeDueDate = useMemo(() => {
    if (!activeDueDateItem.value) return '';
    onDueDateSelected(getFutureDateFromSpecificDate(activeDueDateItem.value, issueDate), activeDueDateItem.id);
    return refactoredTimeAndDate(getFutureDateFromSpecificDate(activeDueDateItem.value, issueDate).toDateString(), 'InvoiceCreation', DATE_FORMAT.LETTERS, false);
  }, [activeDueDateItem, issueDate]);

  useEffect(() => {
    setSelectedDueDateItemId(0);
  }, [issueDate]);

  useEffect(() => {
    window.addEventListener('click', (e: any) => {
      if (elWrapper?.current?.contains(e.target)) {
        // Clicked inside
      } else {
        setIsDatePickerShown(false);
      }
    });
    return () => {
      window.removeEventListener('click', () => {});
    };
  }, []);

  return (
    <div ref={elWrapper} className={componentStyles.DUE_DATE_CONTENT_WRAPPER}>
      <Button
        childElement={(
          <div className='flex items-center'>
            <Heading title={activeDueDate} className={componentStyles.PICKER_CONTENT_HEADER} />
            <Icon src={ArrowIcon} className={componentStyles.DUE_DATE_PICKER_CONTENT_ICON} />
          </div>
            )}
        onClick={() => setIsDatePickerShown(!isDatePickerShown)}
        className={componentStyles.PICKER_TRIGGER_BUTTON}
        id='elButtonDueDatePickerTrigger'
      />
      <Heading title={activeDueDateItem.title} className={componentStyles.DUE_DATE_SUB_TITLE} />
      {isDatePickerShown && (
      <div className={componentStyles.FLOATING_WRAPPER}>
          {dueDates.map((item: IDueDateItem, idx: number) => (
            <div key={item.title}>
              <Button
                className={componentStyles.DUE_DATE_TRIGGER_BUTTON}
                childElement={(
                  <div className={componentStyles.DUE_DATE_ITEM_WRAPPER}>
                    <Heading title={item.title} className={componentStyles.DUE_DATE_ITEM_HEADER} />
                    {item.value && <Heading title={refactoredTimeAndDate(getFutureDateFromSpecificDate(item.value, issueDate).toDateString(), 'InvoiceCreation', DATE_FORMAT.LETTERS, false)} className={componentStyles.DUE_DATE_ITEM_SUB_HEADER} />}
                  </div>
              )}
                id={`dueDateItem_${item.title}`}
                onClick={() => handleItemClick(idx)}
              />
            </div>
          ))}
      </div>
      )}

    </div>
  );
};
